// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { openBackOrdersFilterStyles } from "@steiner/App/Widgets/OpenBackOrders/OpenBackOrdersFilter";
import { css } from "styled-components";

openBackOrdersFilterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

openBackOrdersFilterStyles.buttonsItem = {
    width: [12, 12, 6, 12, 12],
    css: css`
        &&& {
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

openBackOrdersFilterStyles.gridItemStyle = {
    width: [12, 12, 6, 4, 4],
};

openBackOrdersFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

openBackOrdersFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

openBackOrdersFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
